module.exports = __webpack_public_path__ + "static/media/print-id.a61fbdcb.svg";